export default {
  activateLandingPageTitle: 'Veranstaltungen',
  activateProductCardTitle: 'Veranstaltungen',
  activateProductPageTitle: 'Veranstaltungen buchen',
  allProductsLandingPageTitle: 'Einzigartige Erlebnisse buchen',
  apply: 'Anwenden',
  buyTickets: 'Tickets kaufen',
  cancel: 'Abbrechen',
  clear: 'Löschen',
  clearFilters: 'Filter löschen',
  discoverExperiences: 'Erlebnisse entdecken',
  exclusive: 'Exklusiv',
  experience: 'Erlebnis',
  experiencePhotoOfListing:
    'Erlebnisfoto {{photoNumber}} von Inserat {{listingTitle}}',
  experiences: 'Erlebnisse',
  filterExperiences: 'Erlebnisse filtern',
  fromListingCard: 'Von',
  hostedBy: 'Gastgeber: ',
  hostLandingPageTitle: 'Lokale Erlebnisse',
  hostProductCardTitle: 'Lokale Erlebnisse',
  hostProductPageTitle: 'Lokale Erlebnisse buchen',
  landingPageTitle: 'Einzigartige Erlebnisse buchen',
  mainLandingPageTitle: 'Alle Erlebnisse',
  more: 'Mehr',
  noExperiencesFound: 'Keine Erlebnisse gefunden',
  noExperiencesFoundFor: 'Keine Erlebnisse gefunden für',
  experiencesFoundCount: '{{count}} Erlebnisse gefunden',
  profileImageOfHost: 'Profilbild des Gastgebers {{hostName}}',
  reserve: 'Reservieren',
  reserveLandingPageTitle: 'Aktivitäten & Annehmlichkeiten',
  reserveProductCardTitle: 'Aktivitäten',
  reserveProductPageTitle: 'Aktivitäten & Annehmlichkeiten buchen',
  resultsPageTitle: 'Erlebnisse & Aktivitäten buchen',
};
